import { presets } from './presets'
import { renderBullet } from './icons/renderBullet'

function deepMerge(target, source) {
  const out = { ...target }
  Object.keys(source).forEach((key) => {
    const value = source[key]
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      out[key] = deepMerge(out[key] || {}, value)
    } else {
      out[key] = value
    }
  })
  return out
}

/**
 * Build Swiper options from preset name + overrides.
 */
export function getSwiperOptions({
  preset = 'default',
  overrides = {},
  navigationElements = {},
  paginationElement = null,
  react = false,
}) {
  const base = presets[preset] || presets.default
  const options = deepMerge(base, overrides)

  if (react) {
    options.pagination = {
      ...(options.pagination || {}),
      clickable: true,
      renderBullet: options.pagination?.renderBullet || renderBullet,
    }
    delete options.pagination.el

    if (overrides.navigation !== false) {
      options.navigation = overrides.navigation ?? true
    }

    return options
  }

  if (navigationElements.prevEl && navigationElements.nextEl) {
    options.navigation = {
      addIcons: false,
      ...(options.navigation || {}),
      prevEl: navigationElements.prevEl,
      nextEl: navigationElements.nextEl,
      disabledClass: 'swiper-button-disabled',
    }
  }

  if (paginationElement && options.pagination !== false) {
    options.pagination = {
      ...(options.pagination || {}),
      el: paginationElement,
      clickable: true,
      renderBullet: options.pagination?.renderBullet || renderBullet,
    }
  }

  return options
}
